import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";
import {
  EmailLogDetailsResponse,
  EmailLogsListParams,
  EmailLogsListResponse,
  EmailLogStatsResponse,
} from "../models/EmailLogs/EmailLogsModel";

const compactParams = (params: EmailLogsListParams = {}) => {
  const query: Record<string, string | number> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    query[key] = value as string | number;
  });
  return query;
};

class EmailLogsService {
  private api: AxiosInstance;

  constructor() {
    this.api = createApiClient();
  }

  public async listLogs(
    params: EmailLogsListParams = {},
  ): Promise<EmailLogsListResponse> {
    const response = await this.api.get<EmailLogsListResponse>(
      "/adminPanel/email-logs",
      { params: compactParams(params) },
    );
    return response.data;
  }

  public async getStats(): Promise<EmailLogStatsResponse> {
    const response = await this.api.get<EmailLogStatsResponse>(
      "/adminPanel/email-logs/stats/summary",
    );
    return response.data;
  }

  public async getLogDetails(
    emailLogId: string,
  ): Promise<EmailLogDetailsResponse> {
    const response = await this.api.get<EmailLogDetailsResponse>(
      `/adminPanel/email-logs/${encodeURIComponent(emailLogId)}`,
    );
    return response.data;
  }
}

export const emailLogsService = new EmailLogsService();
